import React, { memo } from "react";
import { Center, Text } from "@chakra-ui/react";
import colors from "app/colors";
import { DRAWER_WIDTH_PX } from "modules/utils/Constants";
import { MESSAGE_COMPOSER_DROP_OVERLAY_Z_INDEX } from "modules/providers/chakra-provider/chakra-portal-stack";

interface IProps {
  isDragActive: boolean;
  width?: number;
}

const DropFilesHere = ({ isDragActive, width }: IProps) => (
  <Center
    opacity={isDragActive ? 1 : 0}
    transition="opacity 90ms ease-in"
    visibility={isDragActive ? "visible" : "hidden"}
    position="absolute"
    height="100%"
    backgroundColor={colors.transparentWhite}
    width={DRAWER_WIDTH_PX}
    zIndex={MESSAGE_COMPOSER_DROP_OVERLAY_Z_INDEX}
    display="flex"
    borderWidth={1}
    borderStyle="dashed"
    w={width}
  >
    <Text fontWeight="semibold" fontStyle="italic" fontSize="lg">
      Drop here to upload file(s)
    </Text>
  </Center>
);

export default memo(DropFilesHere);
